import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'antd';
import { authOperations } from '../../redux/auth';
import { authSelectors } from '../../redux/auth';
import s from './UserMenu.module.css';
import defaultAvatar from './default-avatar.png';

export default function UserMenu() {
  const dispatch = useDispatch();
  const avatarURL = useSelector(authSelectors.getUserAvatar);
  const avatar = avatarURL || defaultAvatar;
  const email = useSelector(authSelectors.getUserEmail);
  const name = useSelector(authSelectors.getUserName);

  return (
    <div className={s.container}>
      <img src={avatar} alt="user_avatar" width="32" className={s.avatar} />
      <div className={s.userData}>
        <span className={s.name}>Welcome, {name}</span>
        <span className={s.email}>{email}</span>
      </div>
      <Button
        type="primary"
        danger
        onClick={() => dispatch(authOperations.logOut())}
      >
        Sign Out
      </Button>
    </div>
  );
}
